import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Layout from '../components/Layout'
import { blogAuthorPropType, blogPostPropType } from '../constants/propTypes'
import AuthorSideBar from '../components/Blog/AuthorSideBar'
import PaginatedItems from '../components/Blog/PaginatedItems'
import Crumbs from '../components/Blog/Crumbs'
import Query from '../components/Blog/Query'
import { getTwitterUsername } from '../helpers/url'

const Container = styled.div`
  margin-top: 12rem;
`

const Side = styled.div`
  display: inline-block;
  width: 30%;
  vertical-align: top;
  padding-left: 1rem;
  margin-top: 4rem;
  border-left: 0.1rem solid ${({ theme }) => theme.colors.primaryHighlight};
  padding-bottom: 1rem;

  @media screen and (max-width: 1000px) {
    display: block;
    width: 100%;
  }
`

const BlogAuthor = ({ pageContext }) => (
  <Query
    render={(content, meta) => (
      <Layout
        headData={{
          title: `IOHK ${content.title} - ${
            pageContext.display_name || pageContext.title
          }`,
          meta: [
            {
              name: 'description',
              content: meta.blog_author_posts_by.replace(
                '{{ author }}',
                pageContext.display_name || pageContext.title
              )
            },
            {
              name: 'twitter:description',
              content: meta.blog_author_posts_by.replace(
                '{{ author }}',
                pageContext.display_name || pageContext.title
              )
            },
            {
              name: 'twitter:title',
              content: `${
                pageContext.display_name || pageContext.title
              } - IOHK ${content.title}`
            },
            {
              name: 'og:description',
              content: meta.blog_author_posts_by.replace(
                '{{ author }}',
                pageContext.display_name || pageContext.title
              )
            },
            {
              name: 'og:title',
              content: `${
                pageContext.display_name || pageContext.title
              } - IOHK ${content.title}`
            },
            { name: 'twitter:image', file: pageContext.thumbnail },
            { name: 'og:image', file: pageContext.thumbnail },
            {
              name: 'twitter:image:alt',
              content: pageContext.display_name || pageContext.title
            },
            {
              name: 'og:image:alt',
              content: pageContext.display_name || pageContext.title
            },
            {
              name: 'twitter:creator',
              content: `@${getTwitterUsername(
                pageContext.profile_links.twitter
              )}`
            }
          ]
        }}
      >
        <Container>
          <Crumbs crumbs={pageContext.crumbs} />
          <PaginatedItems
            posts={pageContext.blog_posts.map((post) => ({
              ...post,
              author: { ...pageContext }
            }))}
            totalPages={pageContext.total_pages}
            currentPage={pageContext.current_page}
          />
          <Side>
            <AuthorSideBar
              filters={pageContext.filters}
              recentPosts={pageContext.recentPosts}
              {...pageContext}
            />
          </Side>
        </Container>
      </Layout>
    )}
  />
)

BlogAuthor.propTypes = {
  pageContext: PropTypes.shape({
    ...blogAuthorPropType,
    recentPosts: PropTypes.arrayOf(PropTypes.shape(blogPostPropType))
      .isRequired,
    total_pages: PropTypes.number.isRequired,
    current_page: PropTypes.number.isRequired,
    filters: PropTypes.object.isRequired,
    crumbs: PropTypes.array.isRequired
  }).isRequired
}

export default BlogAuthor
